import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AccountService } from './accountService.service';
import 'rxjs';

export class Languages {
    private name;
    private lang;
    private jsonURL;
    private iconURL;
    private id;
    private misc_locale;
    private format;

    constructor(name: string, jsonURL: string, iconURL: string, id: number, mish_locale, lang: string, format) {
        this.name = name;
        this.jsonURL = jsonURL;
        this.iconURL = iconURL;
        this.id = id;
        this.misc_locale = mish_locale;
        this.lang = lang;
        this.format = format;
    }

    getName() {
        return this.name;
    }

    getJsonURL() {
        return this.jsonURL;
    }

    getIconURL() {
        return this.iconURL;
    }

    getId() {
        return this.id;
    }

    getMishLocale() {
        return this.misc_locale;
    }

    getLang() {
        return this.lang;
    }

    getFormat() {
        return this.format;
    }
}

@Injectable()
export class Locale {

    public terms = undefined;
    public miscTerms = undefined;


    private passwordParameters;
    private languages = [];
    private locales = null;
    private currentLanguage = 0;

    private land1 = '';
    private landx = '';

    private accountService: AccountService;

    private preferred_language;
    constructor(private http: Http) {
        this.preferred_language = navigator.language.toUpperCase();
        this.launchLocale();
    }

    getPreferredLanguage() { 
        const language = this.preferred_language.substring(0, this.preferred_language.indexOf('-'));
        return language;
    }

    launchLocale() {
        this.getAvailableLanguages().subscribe(data => this.setAvailableLocale(data));
    }

    setAccountService(accountService: AccountService) {
        this.accountService = accountService;
    }

   setAvailableLocale(value) {
       this.passwordParameters = value.passwordParameters;
       this.currentLanguage = -1;
        for (let a = 0; a < value.languages.length; a++) {
            this.languages.push(new Languages(value.languages[a].name, value.languages[a].localeFile,
                                            value.languages[a].icon, a, value.languages[a].misc,
                                            value.languages[a].lang, value.languages[a].format));
        }
        for (let i = 0; i < this.languages.length; i++) {
            console.log((this.languages[i].lang[0] + this.languages[i].lang[1]), (this.preferred_language[0] + this.preferred_language[1]));
            if ((this.languages[i].lang[0] + this.languages[i].lang[1]) === (this.preferred_language[0] + this.preferred_language[1])) {
                this.currentLanguage = i;
            }
        }

        if (this.currentLanguage === -1) {
            this.currentLanguage = value.defaultLang;
        }
        this.preferred_language = this.languages[this.currentLanguage].lang;
        this.miscTerms = this.languages[this.currentLanguage].getMishLocale();
        this.getLocal(this.languages[this.currentLanguage].getJsonURL()).subscribe(data => this.terms = data);
    }

    getDefaultLanguage() {
        let i = 0;
        let elementCode = '';
        const preferredLanguageCode = this.getPreferredLanguage().charAt(0) + this.getPreferredLanguage().charAt(1);
        for (const element of this.languages) {
            elementCode = element.getLang().charAt(0) + element.getLang().charAt(1);
            if (elementCode === preferredLanguageCode) {
                return i;
            } else {
                i ++;
            }
        }
        return 0;
    }

    getAvailableLanguages() {
        return this.http.get('assets/translations/locale.json')
            .map((res: any) => res.json());
    }

    getLocal(jsonURL: string) {
        this.miscTerms = this.languages[this.currentLanguage].getMishLocale();
        return this.http.get(jsonURL)
            .map((res: any) => res.json());

    }

    getCurrentLanguageIconUrl() {
        return this.languages[this.currentLanguage].iconURL;
    }

    getLanguageName() {
        return this.languages[this.currentLanguage].name;
    }

    changeLanguage() {
        this.currentLanguage++;
        if (this.currentLanguage === this.languages.length) {
            this.currentLanguage = 0;
        }
        this.getLocal(this.languages[this.currentLanguage].getJsonURL()).subscribe(data => this.terms = data);
        this.preferred_language = this.languages[this.currentLanguage].getLang();
        this.accountService.loadParameters().subscribe();
    }

    getTerms() {
        return this.terms;
    }

    getMiscTerms() {
        return this.miscTerms;
    }

    setLanguageOfId(value: number) {
        this.currentLanguage = value;
        this.preferred_language = this.languages[this.currentLanguage].getLang();
        this.getLocal(this.languages[this.currentLanguage].getJsonURL()).subscribe(
            data => this.terms = data
        );
    }

    setLand1(value) { this.land1 = value; }
    setLandx(value) { this.landx = value; }
    getLand1() { return this.land1; }
    getLandx() { return this.landx; }

    getDateFormat() {
        return this.languages[this.currentLanguage].getFormat().date;
    }

    getThousandsFormat() {
        return this.languages[this.currentLanguage].getFormat().thousands;
    }

    getDecimalsFormat() {
        return this.languages[this.currentLanguage].getFormat().decimals;
    }

    getCurrencyLang() {
        return this.languages[this.currentLanguage].getFormat().currencyLANG;
    }

    getCurrencyCode() {
        return this.languages[this.currentLanguage].getFormat().currencyISO;
    }

    formatPrice(value = 0, baseCurrency = '') {
        if (baseCurrency === '') {
            return value.toLocaleString(this.getCurrencyLang(), { style: 'currency', currency: this.getCurrencyCode()});
        } else {
            return value.toLocaleString(this.getCurrencyLang(), { style: 'currency', currency: baseCurrency});
        }

    }

    getPasswordParams() {
        return this.passwordParameters;
    }

}



// WEBPACK FOOTER //
// ./src/app/service/locale.service.ts